import { GET_QUESTION } from "@/config/api";
import HandlePhpFetch from "@/src/utils/fetch/PhpFetch";

export const getQuestion = () => {
  return HandlePhpFetch.get(GET_QUESTION);
};
